"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_toolbar_piped_text_html_1 = __importDefault(require("./widget-toolbar-piped-text.html"));
(function (module) {
    module.component('prWidgetToolbarPipedText', {
        templateUrl: widget_toolbar_piped_text_html_1.default,
        bindings: {
            items: '<',
            action: '&'
        }
    });
})(angular.module('qualtrics.pr'));
